import styled, { css } from 'styled-components';
import { ifProp } from 'styled-tools';

export const MaskableContent = styled.div<{ showMask: boolean }>`
  position: relative;
  ${ifProp(
    'showMask',
    css`
      opacity: 0.6;
      &:after {
        content: '';
        cursor: not-allowed;
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        z-index: var(--zindex-layer-00);
      }
    `,
  )};
`;
